import React from 'react'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'

import { CarouselContainer } from 'ui/acro'
import { useSwiper } from 'hooks'

import CategoryCard from './CategoryCard'

const Carousel = ({ categories }) => {
  const { getSwiperProps } = useSwiper()

  return (
    <CarouselContainer>
      <Swiper
        {...getSwiperProps({
          lazy: true,
          slidesPerView: 'auto',
          spaceBetween: 16,
          slidesOffsetBefore: 15,
          slidesOffsetAfter: 15,
          watchOverflow: true,
          freeMode: true,
          freeModeSticky: true
        })}
      >
        {categories &&
          categories.map((item, index) => (
            <SwiperSlide tag={CategoryCard} {...item} key={index} />
          ))}
      </Swiper>
    </CarouselContainer>
  )
}

Carousel.propTypes = {
  categories: PropTypes.array
}

export default Carousel
